module.exports = __webpack_public_path__ + "assets/img/btn_scancode.ecac0e28.svg";